if (typeof i18n == "undefined"){
  var i18n = {};
}

i18n.previousMonth = 'Previous Month';
i18n.nextMonth     = 'Next Month';
i18n.months        = ['January','February','March','April','May','June','July','August','September','October','November','December'];
i18n.weekdays      = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
i18n.weekdaysShort = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
